import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";
import * as React from "react";

interface StickyMobileCTAProps {
  onClick: () => void;
}

export default function StickyMobileCTA({ onClick }: StickyMobileCTAProps) {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      className="fixed bottom-4 left-4 right-4 z-50 md:hidden"
    >
      <button
        onClick={onClick}
        className="w-full bg-gradient-to-r from-[#CFAE58] to-[#B89A45] text-white py-4 px-6 rounded-full shadow-2xl hover:shadow-[#CFAE58]/50 flex items-center justify-center gap-2"
      >
        <span className="text-lg">سجّل الآن</span>
        <TrendingUp className="w-5 h-5" />
      </button>
    </motion.div>
  );
}
